import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from './firebase/auth';
import './index.css';

// Auto-reload once if a deployed JS chunk fails to load.
// This helps fix blank screens caused by stale deploy cache / missing chunks.
const handleChunkLoadFailure = (message) => {
  const msg = String(message || '');

  const isChunkError =
    msg.includes('Loading chunk') ||
    msg.includes('ChunkLoadError') ||
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed');

  if (!isChunkError) return;

  try {
    const alreadyReloaded = sessionStorage.getItem('elevate:chunkReloaded');

    if (!alreadyReloaded) {
      sessionStorage.setItem('elevate:chunkReloaded', '1');
      window.location.reload();
    }
  } catch {
    window.location.reload();
  }
};

window.addEventListener('error', (event) => {
  handleChunkLoadFailure(event?.message);
});

window.addEventListener('unhandledrejection', (event) => {
  handleChunkLoadFailure(event?.reason?.message || event?.reason);
});

setTimeout(() => {
  try {
    sessionStorage.removeItem('elevate:chunkReloaded');
  } catch {}
}, 5000);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);